import React, { useState, useEffect } from 'react';
import { Stack, YStack, XStack, SizableText, Separator, useTheme, ScrollView } from 'tamagui';
import { Link } from 'solito/link';
import { Bookmark } from 'components/utility/Buttons';
import { readArticleToggle } from 'controllers/ReadArticleController';
import Loading from 'components/utility/Loading';
import { Flex, Center } from 'components/base/General';
import { ColorButton } from 'components/utility/Buttons';
import { DetailHeader } from 'app/components/base/Detail';
import { StarButton } from 'components/utility/Buttons';
import { useGetCollectionWithArticlesQuery, useCreateOrUpdateBookmarkMutation, useDeleteBookmarkMutation } from 'utils/RTKGraphQL';
import { useSelector } from 'react-redux';
import Breadcrumb from 'app/components/utility/Breadcrumb';
const ArticleItem = ({
  article
}) => {
  const [read, setRead] = useState(article.read);
  const theme = useTheme();
  const _readArticleToggle = async () => {
    await readArticleToggle(article);
    setRead(!read);
  };
  const getArticleStatus = () => {
    if (article.perLanguage[0]?.premium > 1) {
      return 'Premium';
    } else if (article.perLanguage[0]?.premium === 1) {
      return 'Login';
    }
    return null;
  };
  const articleStatus = getArticleStatus();
  return /*#__PURE__*/React.createElement(XStack, {
    disabled: true,
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "$gray400",
    backgroundColor: '$warmgray200',
    $base: {
      maxWidth: '100%',
      gap: 10
    },
    $sm: {
      maxWidth: '95%',
      width: '95%'
    },
    $md: {
      width: '700px'
    },
    $lg: {
      width: '900px'
    },
    $xl: {
      width: '1100px'
    },
    p: 15
  }, /*#__PURE__*/React.createElement(YStack, {
    flexShrink: 1,
    flexGrow: 1,
    $md: {
      flexDirection: 'row'
    },
    alignItems: "flex-start",
    gap: 20
  }, /*#__PURE__*/React.createElement(SizableText, {
    flexShrink: 1,
    flexWrap: "wrap"
  }, article.title), articleStatus && /*#__PURE__*/React.createElement(SizableText, {
    fontSize: "$xs",
    color: articleStatus === 'Premium' ? '$red500' : 'black',
    fontWeight: "bold"
  }, articleStatus)), /*#__PURE__*/React.createElement(XStack, {
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 20,
    flexShrink: 0,
    disabled: true
  }, /*#__PURE__*/React.createElement(Link, {
    href: `/article/${article.slug}`
  }, /*#__PURE__*/React.createElement(ColorButton, {
    width: 100,
    title: "Read",
    disabled: true
  })), /*#__PURE__*/React.createElement(StarButton, {
    disabled: true,
    saved: read,
    onPress: _readArticleToggle
  })));
};
const CollectionPage = ({
  slug,
  userId,
  profileId
}) => {
  const theme = useTheme();
  const profile = useSelector(state => state.profile);
  const [bookmark, setBookmark] = useState(true);
  const {
    data,
    isLoading,
    error
  } = useGetCollectionWithArticlesQuery({
    slug,
    userId: profile?.id
  }, {
    skip: !slug
  });
  const [createOrUpdateBookmark] = useCreateOrUpdateBookmarkMutation();
  const [deleteBookmark] = useDeleteBookmarkMutation();
  const _bookmarkToggle = async () => {
    if (bookmark) {
      await deleteBookmark({
        userId: profile.id || userId,
        collectionId: data.id
      });
    } else {
      await createOrUpdateBookmark({
        userId: profile.id || userId,
        collectionId: data.id
      });
    }
    setBookmark(!bookmark);
  };
  useEffect(() => {
    if (data) {
      setBookmark(data.bookmarked);
    }
  }, [data]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Flex, {
      flexGrow: 1,
      bg: theme.background,
      alignSelf: "center",
      justifyContent: "center",
      width: "100%",
      minHeight: 500
    }, /*#__PURE__*/React.createElement(Loading, null));
  }
  if (error) {
    return null;
  }
  if (!data || !data.collectionPerLanguage || data.collectionPerLanguage.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ScrollView, {
    bg: theme.background
  }, /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(DetailHeader, {
    article: data,
    perLanguage: data.collectionPerLanguage[0]
  }), /*#__PURE__*/React.createElement(Stack, {
    mt: 60,
    py: 20,
    mx: 20,
    alignItems: "center",
    justifyContent: "space-around",
    borderColor: "transparent",
    borderWidth: 1,
    display: "flex",
    gap: 20,
    $base: {
      maxWidth: '95%',
      flexDirection: 'column'
    },
    $sm: {
      flexDirection: 'column'
    },
    $md: {
      borderColor: 'black',
      flexDirection: 'row',
      gap: 0,
      maxWidth: 1100
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    $base: {
      width: '95%'
    },
    $md: {
      width: '80%'
    }
  }, /*#__PURE__*/React.createElement(SizableText, null, data.collectionPerLanguage[0].description)), profile && /*#__PURE__*/React.createElement(Bookmark, {
    saved: bookmark,
    onPress: _bookmarkToggle,
    size: 80,
    color: "$pred500"
  })), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(Stack, {
    py: 50
  }, /*#__PURE__*/React.createElement(Breadcrumb, {
    skipSegments: ['collection']
  }), /*#__PURE__*/React.createElement(YStack, {
    gap: 20,
    alignItems: "center"
  }, data.articles.map(article => /*#__PURE__*/React.createElement(ArticleItem, {
    key: article.id,
    article: article
  }))))));
};
export default CollectionPage;